import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { home, system_manager } from '../../assets/conf_urls.json';
import { monitorProvisionObj, resultObj } from './home.models';

@Injectable()

export class HomeService {
  dataToBeTransmitted = new BehaviorSubject<resultObj>(null)

  constructor(private http: HttpClient) {
  }

  getVMSStatistics(): Observable<{ data: resultObj }> {
    return this.http.post<{ data: resultObj }>(home.statistics, {})
  }

  getUnprovisionedUnits(): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(system_manager.services, { "event": "select_unprovisioned_units" })
  }

  getProvisionedUnits(): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(system_manager.services, { "event": "select_provisioned_units" })
  }

  getUnmonitoredUnits(): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(system_manager.services, { "event": "select_unmonitored_units" })
  }

  getMonitoredUnits(): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(system_manager.services, { "event": "select_monitored_units" })
  }

  getInACallUnits(): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(system_manager.services, { "event": "select_inCall_units" })
  }

  getNoResponseUnits(): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(system_manager.services, { "event": "select_noResponse_units" })
  }

  getIdleUnits(): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(system_manager.services, { "event": "select_idle_units" })
  }

  getIncorrectPasswordUnits(): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(system_manager.services, { "event": "select_incorrect_password_units" })
  }

  getInRelayErrorUnits(): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(system_manager.services, { "event": "select_relay_issue_units" })
  }

  provisionUnit(system_ip: string): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": "startProvision",
      "ip": system_ip
    })
  }

  unProvisionUnit(system_ip: string): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": "unprovisionSystem",
      "ip": system_ip
    })
  }

  monitorUnit(system_ip: string, flag: Number): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": 'monitorOrUnmonitorSystem',
      "system_ip": system_ip,
      "flag": flag
    })
  }

  unMonitorUnit(system_ip: string, flag: Number): Observable<any> {
    return this.http.post<any>(system_manager.services, {
      "event": 'monitorOrUnmonitorSystem',
      "system_ip": system_ip,
      "flag": flag
    })
  }

  bulkMonitor(units: string): Observable<any> {
    return this.http.post<any>(home.bulkActions, {
      "event": 'monitor',
      "data": units
    })
  }

  bulkUnMonitor(units: string): Observable<any> {
    return this.http.post<any>(home.bulkActions, {
      "event": 'unmonitor',
      "data": units
    })
  }

  bulkProvision(units: string[]): Observable<any> {
    return this.http.post<any>(home.bulkActions, {
      "event": 'provision',
      "data": units
    })
  }

  bulkUnProvision(units: string[]): Observable<any> {
    return this.http.post<any>(home.bulkActions, {
      "event": 'unprovision',
      "data": units
    })
  }

  pullAllUnitsConfigurationFiles(userWhoMadeRequest: string): Observable<any> {
    return this.http.post<{ data: any[] }>(system_manager.services, {
      "event": "pull_all_units_configuration_files",
      "requested_by": userWhoMadeRequest
    })
  }

  refreshPhonebook(userWhoMadeRequest: string): Observable<any> {
    return this.http.post<{ data: any[] }>(system_manager.services, {
      "event": "refresh_phonebook",
      "requested_by": userWhoMadeRequest
    })
  }

}
